import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
// eslint-disable-next-line max-len
import { DelegateSessionConnectionBoxBody } from 'components/Page/Header/TopHeader/Profile/DelegateSessionConnectionBox/DelegateSessionConnectionBox';
import { getEstimateById, getEstimateClient, updateB2BCounterParties } from 'domains/estimate/Estimate.store';
import { CenteredSpin, Flex, LightCard, Text } from 'UI';
import { getData } from 'utils';

export interface ClientSectionProps {
  estimateId: string;
}

const ClientSectionB2B = ({ estimateId }: ClientSectionProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const estimate = getData(useSelector((state: RootState) => getEstimateById(state, estimateId)));
  const [selectedSellerTresorCode, setSelectedSellerTresorCode] = useState<string | undefined>();
  const [selectedBuyerTresorCode, setSelectedBuyerTresorCode] = useState<string | undefined>();
  const [expandSellersSelector, setExpandSellersSelector] = useState(false);
  const [expandBuyersSelector, setExpandBuyersSelector] = useState(false);
  const client = useSelector((state: RootState) => getEstimateClient(state, estimateId));
  const name = client?.name || '';
  const birCode = client?.tresorCode || '';
  const rrfCode = client?.rrfCode || '';
  const phoneNumber = client?.phoneNumber || '';
  const email = client?.email || '';

  const handleChangeBuyer = (buyer?: string) => {
    setSelectedBuyerTresorCode(buyer);
    selectedSellerTresorCode &&
      buyer &&
      dispatch(updateB2BCounterParties({ sellerTresorCode: selectedSellerTresorCode, buyerTresorCode: buyer }));
  };

  useEffect(() => {
    estimate?.clientContact.tresorCode && setSelectedBuyerTresorCode(estimate.clientContact.tresorCode);
    // eslint-disable-next-line
  }, [estimate?.clientContact.tresorCode]);

  useEffect(() => {
    client?.sellerTresorCode && setSelectedSellerTresorCode(client.sellerTresorCode);
    // eslint-disable-next-line
  }, [client?.sellerTresorCode]);

  const isReloaded = !selectedBuyerTresorCode || estimate?.clientContact.tresorCode === selectedBuyerTresorCode;

  const setExpandSellers = (v: boolean) => {
    setExpandSellersSelector(v);
    setExpandBuyersSelector(false);
  };

  const setExpandBuyers = (v: boolean) => {
    setExpandBuyersSelector(v);
    setExpandSellersSelector(false);
  };

  return (
    <LightCard title={t('estimate.client_contact', 'Client contact')}>
      <Flex direction={'column'} gap={8}>
        <DelegateSessionConnectionBoxBody
          selectedSellerTresorCode={selectedSellerTresorCode}
          setSelectedSeller={setSelectedSellerTresorCode}
          selectedBuyerTresorCode={selectedBuyerTresorCode}
          setSelectedBuyerTresorCode={handleChangeBuyer}
          expandSellersSelector={expandSellersSelector}
          setExpandSellersSelector={setExpandSellers}
          expandBuyersSelector={expandBuyersSelector}
          setExpandBuyersSelector={setExpandBuyers}
          clickable
          inline
          dropDownInputs
        />
        <Flex direction={'column'} gap={5} data-cy={'client-contact-info'}>
          {isReloaded ? (
            <>
              {name && (
                <Text type="base" data-cy={'client-name'}>
                  {name}
                </Text>
              )}
              {(birCode || rrfCode) && (
                <Text type="base" data-cy={'client-bir-code'}>{`${t(
                  'common.bir_code',
                  'Bir code:',
                )} ${birCode} - ${rrfCode}`}</Text>
              )}
              {phoneNumber && (
                <Text type="base" data-cy={'client-phone-number'}>
                  {phoneNumber}
                </Text>
              )}
              {email && (
                <Text type="base" data-cy={'client-email'}>
                  {email}
                </Text>
              )}
            </>
          ) : (
            <CenteredSpin />
          )}
        </Flex>
      </Flex>
    </LightCard>
  );
};

export default ClientSectionB2B;
